import {Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router, RouterLinkWithHref} from '@angular/router';
import {LinkRef, ResolverUrl} from '@kion/data-models';
import {LocationStrategy} from '@angular/common';
import {BaseLinkResolverService} from '../services/base-link-resolver.service';
import {BasePathConfig} from '../config/basePath.config';
import {CmsConfig} from "@kion/libs/lmh/cms/src/lib/config/cms.config";

//TODO: http / mailto / tel links need to wait at a bit before using the linkResolver
// idk why but this need to be fixed

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'a[customRouterLink]'
})
export class LinkResolverDirective extends RouterLinkWithHref implements OnInit, OnChanges {

  constructor(
    router: Router,
    route: ActivatedRoute,
    locationStrategy: LocationStrategy,
    private linkResolverService: BaseLinkResolverService,
    private basePathConfig: BasePathConfig,
    private element: ElementRef,
    private cmsConfig: CmsConfig
  ) {
    super(router, route, locationStrategy);
  }

  // tslint:disable-next-line:no-input-rename
  @Input('customRouterLink') link: string | LinkRef;
  // tslint:disable-next-line:no-input-rename
  @Input('active') active = true;

  private static generateLink(resolverUrl: ResolverUrl): string {
    let url = resolverUrl.url;
    if (url) {
      if (url.indexOf('mailto:') !== -1 || url.indexOf('tel:') !== -1 || url.indexOf('http') !== -1){
        return url;
      }
      if (!url.startsWith('/')) {
        url = '/' + url;
      }
      url = url.replace('//', '/');
    }
    return url;
  }

  ngOnInit(): void {
    this.setLink();
  }

  ngOnChanges(changes: SimpleChanges): any {
    // FIXME: Quickfix for nwp partner dialog link, not sure if this breaks something in other scenarios, must be
    //  proper handled in the refactoring
    if (typeof (changes?.link?.currentValue) === 'string' &&
      this.cmsConfig.routes.partnerBaseRoute &&
      changes?.link?.currentValue?.includes(this.cmsConfig.routes.partnerBaseRoute)) {
      this.setLink();
    }
  }

  onClick(button: number, ctrlKey: boolean, shiftKey: boolean, altKey: boolean, metaKey: boolean): boolean {
    if (this.href.indexOf('mailto:') !== -1 || this.href.indexOf('tel:') !== -1 || this.href.indexOf('http') !== -1) {
      return true;
    }
    return super.onClick(button, ctrlKey, shiftKey, altKey, metaKey);
  }

  private setLink() {
    const resolverUrl = this.resolveLink();
    let link = LinkResolverDirective.generateLink(resolverUrl);
    if (link) {
      if (link.indexOf('mailto:') !== -1 || link.indexOf('tel:') !== -1 || link.indexOf('http') !== -1) {
        if (resolverUrl.newWindow) {
          this.target = '_blank';
        }
        this.href = link;
        this.element.nativeElement.href = link;
        this.element.nativeElement.removeAttribute('ng-reflect-link');
        return;
      }
      if (this.link) {
        if (typeof this.link !== 'string' && this.link.queryParams) {
          this.queryParams = this.link.queryParams;
          this.queryParamsHandling = 'merge';
        }
      }
      if (resolverUrl.newWindow) {
        this.target = '_blank';
      }
      if (resolverUrl.url.split('#')[1]) {
        this.fragment = resolverUrl.url.split('#')[1];
        link = resolverUrl.url.split('#')[0]
      }
      if (this.active) {
        this.href = this.basePathConfig.basePath.slice(0, -1) + link;
        if (this.fragment) {
          this.href = this.href + '#' + this.fragment
        }
        this.routerLink = link;
      }
    }
  }

  private resolveLink(): ResolverUrl {
    if (typeof this.link === 'string') {
      return {url:this.link};
    }
    if (typeof this.link === 'undefined') {
      return {url:''};
    }
    return this.linkResolverService.navigate(this.link);
  }
}
